module.exports = __webpack_public_path__ + "img/countdown_bg.77578a9c.png";